var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.486,
    height: 42,
    viewBox: "0 0 49.486 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Confirmed",
    transform: "translate(-1776.514 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5331",
    "data-name": "Group 5331",
    transform: "translate(1774.514 185)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4770",
    "data-name": "Path 4770",
    d: "M43.211,42.627V30.383L38.959,24.2,31.136,22.56l-6.576.624L19.912,25.9,18.268,28.8,21.9,31.573,23.143,34.8l.4,6.576v1.247Z",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2906",
    "data-name": "Ellipse 2906",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(8.487 13.214)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4767",
    "data-name": "Path 4767",
    d: "M11.9,24.481a6.9,6.9,0,1,1,6.9-6.9A6.9,6.9,0,0,1,11.9,24.481Zm0-10.741a3.836,3.836,0,1,0,3.836,3.836A3.836,3.836,0,0,0,11.9,13.741Zm16.878,6.138a8.439,8.439,0,1,1,8.439-8.439,8.439,8.439,0,0,1-8.439,8.439Zm0-13.809a5.37,5.37,0,1,0,5.37,5.37A5.37,5.37,0,0,0,28.783,6.069Zm13.042,38.36H15.741a1.534,1.534,0,1,1,0-3.069h24.55V32.8a8.454,8.454,0,0,0-8.439-8.439H25.714a8.439,8.439,0,0,0-7.672,5A1.534,1.534,0,1,1,15.25,28.1a11.477,11.477,0,0,1,10.5-6.813h6.138A11.508,11.508,0,0,1,43.39,32.8v10.1a1.534,1.534,0,0,1-1.565,1.534Z",
    transform: "translate(1.603 0)",
    fill: "#3d4977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4768",
    "data-name": "Path 4768",
    d: "M23.481,36.413H3.534A1.534,1.534,0,0,1,2,34.878v-5.37a11.508,11.508,0,1,1,23.016,0v5.37A1.534,1.534,0,0,1,23.481,36.413ZM5.069,33.344H21.947V29.508a8.439,8.439,0,0,0-16.878,0Z",
    transform: "translate(0 8.016)",
    fill: "#3d4977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4769",
    "data-name": "Path 4769",
    d: "M7.534,29.218A1.534,1.534,0,0,1,6,27.683V24.615a1.534,1.534,0,1,1,3.069,0v3.069A1.534,1.534,0,0,1,7.534,29.218Zm27.619-.23a1.534,1.534,0,0,1-1.534-1.534V24.384a1.534,1.534,0,0,1,3.069,0v3.069A1.534,1.534,0,0,1,35.153,28.988Z",
    transform: "translate(2.138 10.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6171",
    "data-name": "Rectangle 6171",
    width: 3,
    height: 6,
    rx: 1.5,
    transform: "translate(8.487 34.214)",
    fill: "#3d4977"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2907",
    "data-name": "Ellipse 2907",
    transform: "translate(1806 210)",
    fill: "#fff",
    stroke: "#3d4977",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4771",
    "data-name": "Path 4771",
    d: "M-10828.759,2193.82l2.885,2.583,5.971-7.312",
    transform: "translate(12640.259 -1972.59)",
    fill: "none",
    stroke: "#36c96d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.25
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmed);
export default __webpack_public_path__ + "static/media/Confirmed.eac6f91a6e8c8df19b7940486cde688b.svg";
export { ForwardRef as ReactComponent };